// extracted by css-extract-rspack-plugin
export default {"FormControl":"default-issue-create-repository-section-module__FormControl__ZfEP6","SelectedRepo":"default-issue-create-repository-section-module__SelectedRepo__u0Du0"};